var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup record-popup",staticStyle:{"z-index":"20","max-width":"420px"}},[_c('div',{staticClass:"modal-overlay",staticStyle:{"opacity":"0.16"}}),_c('div',{staticClass:"modal-content"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.$t('loading'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }